<div class="default-dialog-header font-weight-normal">
	<h2 mat-dialog-title>
		<span fxFlex>Enter the Last Bid amount for this lane</span>
	</h2>
	<h5 mat-dialog-title>
		<span class="font-size-17" fxFlex
			>To see a more detailed projection of how you are doing on this project please tell us the
			last rate you billed the customer for this lane</span
		>
	</h5>
</div>
<mat-divider></mat-divider>

<form (keydown.enter)="$event.preventDefault()" [formGroup]="lastBidDetails">
	<mat-dialog-content class="default-dialog-content">
		<div class="p-8" fxLayout="row" fxLayoutAlign="center center">
			<mat-form-field class="full-width">
				<mat-icon class="primary-light-color vertical-align-bottom" matPrefix
					>attach_money</mat-icon
				>
				<input
					autocomplete="off"
					formControlName="lastBid"
					mask="separator"
					thousandSeparator=","
					prefix="$"
					matInput
					placeholder="Last Bid Amount"
				/>
			</mat-form-field>
		</div>
	</mat-dialog-content>
	<mat-divider></mat-divider>

	<mat-dialog-actions class="default-dialog-action">
		<div fxFlex="100" fxLayoutAlign="end center" fxLayoutGap="1rem">
			<a (click)="closeDialog(null)"
				><span class="primary-text text-underline cursor-pointer">Cancel</span></a
			>
			<button
				(click)="submitLastBid()"
				[disabled]="lastBidDetails.invalid"
				color="primary"
				mat-raised-button
			>
				Submit
			</button>
		</div>
	</mat-dialog-actions>
</form>
